import React from 'react';
import Panel from './panel';
import Comments from '../comments';

import './styles.scss';

export default function Planner() {
  return <div className="planner-container" >
    <Panel />
    <Comments />
  </div>;
}
